import { PricingCardVariant } from 'components/pricing-card';
import { MutationType, PromotionPlanInfo } from 'store/sagas/apiService/types';
import { PrivateUserMonetizationSource } from 'store/state/app';
import { IMutationResponse } from 'store/state/mutationsResponse/selectors';

export enum Feature {
  Days = 'days',
  ManualPromotion = 'manualPromotion',
  AutoPromotion = 'autoPromotion',
  TargetedBuyers = 'targetedBuyers',
  WhatsApp = 'whatsApp',
}

export interface PromotionPlanFeature {
  id: string;
  text: string;
  disabled?: boolean;
}

export interface PromotionPlanUiData {
  features: PromotionPlanFeature[];
  fullPrice?: number;
  priceSubtext?: string;
  cardCornerLabel?: {
    text: string;
    showCountdown?: boolean;
  };
  cardDescription?: string;
  cardVariant?: PricingCardVariant;
  planTitle: string;
  planSubtitle?: string;
  submitButtonText?: string;
}

export type EnhancedPromotionPlanInfo = PromotionPlanInfo & PromotionPlanUiData;

export interface ISelectPromotionPlanModalProps {
  isOpen: boolean;
  onClose: () => void;
  plans: PromotionPlanInfo[];
  userId: string;
  onPlanSelect: (plan: PromotionPlanInfo, key: string, listingId: string | null) => void;
  listingUploaded?: IMutationResponse<MutationType.NewListing>;
  isHostedFieldsMode?: boolean;
  onHostedFieldsPlanSelect: (plan: PromotionPlanInfo, bulletinId: string | null) => void;
  eventSource?: PrivateUserMonetizationSource;
  bulletinId: string | null;
}
